import { type ReactNode } from 'react';

import { Box, Button, Stack } from '@mui/material';

import { Icon } from '@karehero/llama/components/atoms/Icon/Icon';

// What did not leave the phone, wrapped around whatever it was: a typed message
// or a recording. The alert sits beside it and the way to try again sits under
// it, so the failure belongs to the one thing that failed rather than to the
// conversation.
//
// Around the message rather than inside it, because a bubble and a voice note
// draw nothing alike and both fail the same way. Each one only has to know how
// to look wrong; this knows what to offer about it.
//
// Right-aligned unconditionally: only what they sent can fail to send.
const FailedMessage = ({
  onResend,
  label = 'Tap to resend',
  children,
}: {
  onResend: () => void;
  /** What trying again means here: sending a message, or uploading a file. */
  label?: string;
  children: ReactNode;
}) => (
  <Box sx={{ alignSelf: 'flex-end', maxWidth: '82%' }}>
    <Stack sx={{ alignItems: 'center' }} direction='row' spacing={1}>
      <Box sx={{ color: 'error.main', display: 'flex', flexShrink: 0 }}>
        <Icon icon={'circle-exclamation' as never} fontSize={16} />
      </Box>
      {children}
    </Stack>
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 0.5 }}>
      <Button color='error' size='small' onClick={onResend}>
        {label}
      </Button>
    </Box>
  </Box>
);

export default FailedMessage;
